var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1509 17.2166C23.1509 18.6846 21.9565 19.879 20.4888 19.879H3.51119C2.04346 19.879 0.84906 18.6846 0.84906 17.2166V7.1841C0.84906 5.7161 2.04346 4.52197 3.51119 4.52197L4.84746 4.52223C5.70719 4.52223 6.60826 3.88863 6.89919 3.07957L7.35839 1.80223C7.52719 1.33263 8.11279 0.920898 8.61173 0.920898H15.3883C15.8869 0.920898 16.4725 1.33263 16.6416 1.80223L17.1008 3.07983C17.3917 3.88863 18.2931 4.5225 19.1528 4.5225L20.4888 4.52223C21.9565 4.52223 23.1509 5.71663 23.1509 7.18436V17.2166Z",
    fill: "#0060FF",
    stroke: "#0060FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.2772C9.25547 16.2772 7.02267 14.0447 7.02267 11.2999C7.02267 8.55507 9.25547 6.32227 12 6.32227C14.7445 6.32227 16.9773 8.55507 16.9773 11.2999C16.9773 14.0447 14.7445 16.2772 12 16.2772Z",
    fill: "white",
    stroke: "#0060FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.2772C9.25547 16.2772 7.02267 14.0447 7.02267 11.2999C7.02267 8.55507 9.25547 6.32227 12 6.32227C14.7445 6.32227 16.9773 8.55507 16.9773 11.2999C16.9773 14.0447 14.7445 16.2772 12 16.2772Z",
    fill: "#0060FF",
    fillOpacity: 0.2,
    stroke: "#0060FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic-camera.a7cf47e6c656d65f9dee07905c341bf2.svg";
export { ForwardRef as ReactComponent };